import React from 'react';
import {
  AddressInputElement,
  AddressInputElementClass,
  CurrencyInputElement,
  CurrencyInputElementClass,
  DateInputElement,
  DateInputElementClass,
  DateTimeInputElement,
  DateTimeInputElementClass,
  DocumentElement,
  DropdownElement,
  DropdownElementClass,
  EmailInputElement,
  EmailInputElementClass,
  MultiLineTextInputElement,
  MultiLineTextInputElementClass,
  PhoneNumberInputElement,
  PhoneNumberInputElementClass,
  RatingInputElement,
  RatingInputElementClass,
  SignatureInputElement,
  SignatureInputElementClass,
  SignatureDateInputElement,
  SignatureDateInputElementClass,
  SsnInputElement,
  SsnInputElementClass,
  TableInputElement,
  TableInputElementClass,
  TextBlockElement,
  TextBlockElementClass,
  TextInputElement,
  TextInputElementClass,
  TimeInputElement,
  TimeInputElementClass,
  UrlInputElement,
  UrlInputElementClass,
  YesNoInputElement,
  YesNoInputElementClass,
  DividerInputElementClass,
  DividerInputElement,
  CheckboxInputElement,
  CheckboxInputElementClass,
} from 'types/documentTemplateElement';
import TextInputElementComponent from './elementComponent/TextInputElementComponent';
import MultiLineTextInputElementComponent from './elementComponent/MultiLineTextInputElementComponent';
import PhoneNumberInputElementComponent from './elementComponent/PhoneNumberInputElementComponent';
import YesNoInputElementComponent from './elementComponent/YesNoInputElementComponent';
import SsnInputElementComponent from './elementComponent/SsnInputElementComponent';
import EmailInputElementComponent from './elementComponent/EmailInputElementComponent';
import DateInputElementComponent from './elementComponent/DateInputElementComponent';
import DropdownElementComponent from './elementComponent/DropdownElementComponent';
import AddressInputElementComponent from './elementComponent/AddressInputElementComponent';
import CurrencyInputElementComponent from './elementComponent/CurrencyInputElementComponent';
import DateTimeInputElementComponent from './elementComponent/DateTimeInputElementComponent';
import TimeInputElementComponent from './elementComponent/TimeInputElementComponent';
import RatingInputElementComponent from './elementComponent/RatingInputElementComponent';
import SignatureInputElementComponent from './elementComponent/SignatureInputElementComponent';
import SignatureDateInputElementComponent from './elementComponent/SignatureDateInputElementComponent';
import UrlInputElementComponent from './elementComponent/UrlInputElementComponent';
import TableInputElementComponent from './elementComponent/TableInputElementComponent';
import TextBlockElementComponent from './elementComponent/TextBlockElementComponent';
import DividerInputElementComponent from './elementComponent/DividerInputElementComponent';
import CheckboxInputElementComponent from './elementComponent/CheckboxInputElementComponent';

interface RenderElementViewProps {
  element: DocumentElement;
  updateElement: (updatedElement: DocumentElement) => void;
  mode: 'view' | 'preview' | 'edit' | 'admin';
}

const RenderElementView: React.FC<RenderElementViewProps> = ({
  element,
  updateElement,
  mode,
}) => {
  switch (element.elementType) {
    case 'TextBlock':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <TextBlockElementComponent
            element={element as TextBlockElementClass}
            updateElement={
              updateElement as (updatedElement: TextBlockElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'TextInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <TextInputElementComponent
            element={element as TextInputElementClass}
            updateElement={
              updateElement as (updatedElement: TextInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'MultiLineTextInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <MultiLineTextInputElementComponent
            element={element as MultiLineTextInputElementClass}
            updateElement={
              updateElement as (
                updatedElement: MultiLineTextInputElement,
              ) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'PhoneNumberInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <PhoneNumberInputElementComponent
            element={element as PhoneNumberInputElementClass}
            updateElement={
              updateElement as (updatedElement: PhoneNumberInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'YesNoInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <YesNoInputElementComponent
            element={element as YesNoInputElementClass}
            updateElement={
              updateElement as (updatedElement: YesNoInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'SsnInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <SsnInputElementComponent
            element={element as SsnInputElementClass}
            updateElement={
              updateElement as (updatedElement: SsnInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'EmailInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <EmailInputElementComponent
            element={element as EmailInputElementClass}
            updateElement={
              updateElement as (updatedElement: EmailInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'DateInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <DateInputElementComponent
            element={element as DateInputElementClass}
            updateElement={
              updateElement as (updatedElement: DateInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'Dropdown':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <DropdownElementComponent
            element={element as DropdownElementClass}
            updateElement={
              updateElement as (updatedElement: DropdownElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'AddressInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <AddressInputElementComponent
            element={element as AddressInputElementClass}
            updateElement={
              updateElement as (updatedElement: AddressInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'CurrencyInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <CurrencyInputElementComponent
            element={element as CurrencyInputElementClass}
            updateElement={
              updateElement as (updatedElement: CurrencyInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'DateTimeInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <DateTimeInputElementComponent
            element={element as DateTimeInputElementClass}
            updateElement={
              updateElement as (updatedElement: DateTimeInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'TimeInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <TimeInputElementComponent
            element={element as TimeInputElementClass}
            updateElement={
              updateElement as (updatedElement: TimeInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'RatingInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <RatingInputElementComponent
            element={element as RatingInputElementClass}
            updateElement={
              updateElement as (updatedElement: RatingInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'SignatureInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <div className="w-full mx-3">
            <SignatureInputElementComponent
              element={element as SignatureInputElementClass}
              updateElement={
                updateElement as (updatedElement: SignatureInputElement) => void
              }
              mode={mode}
            />
          </div>
        </div>
      );
    case 'SignatureDateInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <SignatureDateInputElementComponent
            element={element as SignatureDateInputElementClass}
            updateElement={
              updateElement as (
                updatedElement: SignatureDateInputElement,
              ) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'UrlInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <UrlInputElementComponent
            element={element as UrlInputElementClass}
            updateElement={
              updateElement as (updatedElement: UrlInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'TableInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <TableInputElementComponent
            element={element as TableInputElementClass}
            updateElement={
              updateElement as (updatedElement: TableInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'DividerInput':
      return (
        <div className="w-full flex items-center justify-center">
          <DividerInputElementComponent
            element={element as DividerInputElementClass}
            updateElement={
              updateElement as (updatedElement: DividerInputElement) => void
            }
            mode={mode}
          />
        </div>
      );
    case 'CheckboxInput':
      return (
        <div className="w-full h-full min-h-15 flex items-start justify-start">
          <CheckboxInputElementComponent
            element={element as CheckboxInputElementClass}
            updateElement={
              updateElement as (updatedElement: CheckboxInputElement) => void
            }
            mode={mode}
          />
        </div>
      );

    default:
      return null;
  }
};
export default RenderElementView;
